import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full h-full" }
const _hoisted_2 = { class: "relative flex flex-col items-center justify-center" }
const _hoisted_3 = { class: "absolute" }
const _hoisted_4 = { class: "mt-12 text-center" }
const _hoisted_5 = { class: "text-4xl" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "font-extralight" }, "complete", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_doughnut_chart = _resolveComponent("doughnut-chart")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_icon_component, {
        class: "w-48 h-48 mt-8",
        icon: _ctx.Icon.WINGS
      }, null, 8, ["icon"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_doughnut_chart, { percent: _ctx.percentComplete }, null, 8, ["percent"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.percentComplete) + "%", 1),
      _hoisted_6
    ])
  ]))
}